import { Card } from "components/Card/Card";
import { Form, InputConfig } from "components/Form/Form";
import { useLangContext } from "context/Lang";


interface MapFormProps {
    map?: MapType;
    loading?: boolean;
    onSubmit: (data: MapType) => void;
}





export function MapForm({
    map,
    loading,
    onSubmit,
}: MapFormProps) {

    const { gW } = useLangContext();

    const mapFormInputs: InputConfig<MapType>[] = [
        {
            name: "title",
            label: gW("map-name"),
            type: "text",
            placeholder: gW("enter-map-name"),
            required: true,
        },
        {
            name: "description",
            label: gW("description"),
            type: "text",
            placeholder: gW("map-description"),
        },

    ];



    return (
        <Form<MapType>
            className=""
            inputs={mapFormInputs}
            data={map}
            submitTitle={gW(map ? "update-map" : "create-map")}
            loading={loading}
            onSubmit={onSubmit}
        // header={
        //     <h2 className="text-xl font-semibold text-primary-600">
        //         {gW(map ? "update-map" : "create-map")}
        //     </h2>
        // }
        />
    );
}